const translations = {
  "en": {
    "Generate my score": "Generate my score",
    "Generate your real Fitness Score?": "Generate your real Fitness Score?",
    "This replaces your quick-read with the real number.": "This replaces your quick-read with the real number."
  },
  "zh-tw": {
    "Generate my score": "生成我的評分",
    "Generate your real Fitness Score?": "生成你的健康分數？",
    "This replaces your quick-read with the real number.": "已將你的預估值更新為實際數值。"
  }
};

export default translations;
